/** Default Famla project used for « invite process owner » from user menu modals. */
export const INVITE_OWNER_PROJECT_ID = 'b15abbcd-4b91-407a-acf4-58eb7fafbdea';
